import { render, staticRenderFns } from "./ChangePassword.vue?vue&type=template&id=b93479b4&"
import script from "./ChangePassword.vue?vue&type=script&lang=js&"
export * from "./ChangePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/piscinaFacilDev/piscinapp-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b93479b4')) {
      api.createRecord('b93479b4', component.options)
    } else {
      api.reload('b93479b4', component.options)
    }
    module.hot.accept("./ChangePassword.vue?vue&type=template&id=b93479b4&", function () {
      api.rerender('b93479b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/authetication/ChangePassword.vue"
export default component.exports